import React from 'react';

import { Tag } from '../../Elements/Tag/index.tsx';
import { Tooltip } from '../../Feedback/Tooltip/index.tsx';
import { Wrapper, List, ListItem } from './styled.ts';

interface ListWithCounterProps {
  list?: string[];
  defaultVisibleItems?: number;
}

export const ListWithCounter: React.FC<ListWithCounterProps> = React.memo(function ListWithCounter({ list, defaultVisibleItems = 1 }) {
  if (!list) {
    return null;
  }

  const visibleItems = list.slice(0, defaultVisibleItems);
  const hiddenItems = list.slice(defaultVisibleItems);

  return (
    <Wrapper data-testid='content-wrapper'>
      {visibleItems.map((item, index) => (
        <span key={`${item}-${index}`}>{item + (index < visibleItems.length - 1 ? ', ' : '')}</span>
      ))}
      {hiddenItems.length > 0 && (
        <Tooltip
          type='popper'
          contentPadding={false}
          delayHide={150}
          trigger={['hover', 'click']}
          dataTestId='list-counter-tooltip'
          tooltip={
            <List>
              {hiddenItems.map((item) => (
                <ListItem data-testid='list-counter-item' key={item.replace(/\s/g, '')}>
                  {item}
                </ListItem>
              ))}
            </List>
          }>
          <Tag dataTestId='list-counter-tag' title={` +${hiddenItems.length}`} />
        </Tooltip>
      )}
    </Wrapper>
  );
});
